<template>
	<span class="p1 r2 fw7" :class="[computedClass, computedSize]" v-if="label">
		{{ label }}
	</span>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: "neutral" // possible types are `neutral`, `warning`, `success` and `error`
		},
		label: {
			vaidator(val) {
				return typeof val === "string" || val === null
			},
			required: true
		},

		size: {
			type: String,
			default: "medium" // or small, xsmall, large
		}
	},
	computed: {
		computedSize() {
			if (this.size === "xsmall") return "fs2 tt2"
			if (this.size === "small") return "fs2"
			if (this.size === "medium") return "fs3"
			if (this.size === "large") return "fs4"
		},
		computedClass() {
			return {
				"bg6--l5 c4--d5": this.variant === "neutral",
				"bgSuccess--l5 cSucces--d4": this.variant === "success",
				"bgError--l5 cError--d4": this.variant === "error",
				"bgWarning--l4 cWarning--d5": this.variant === "warning"
			}
		}
	}
}
</script>
